import React from "react";

import Logo from "../../Logo/Logo";
import NavigationItems from "../NavigationItems/NavigationItems";
import Backdrop from "../../UI/Backdrop/Backdrop";
import classes from "./SideDrawer.module.css";

interface Props {
  isAuth: boolean;
  isAdmin: boolean;
  isGuest: boolean;
  noOrders: boolean;
  noResults: boolean;
  userFirstName: string | null;
  open: boolean;
  closed: () => void;
}

const sideDrawer = (props: Props) => {
  let attachedClasses = [classes.SideDrawer, classes.Close];
  if (props.open) {
    attachedClasses = [classes.SideDrawer, classes.Open];
  }

  return (
    <React.Fragment>
      <Backdrop show={props.open} clicked={props.closed} />
      <div className={attachedClasses.join(" ")} onClick={props.closed}>
        <div className={classes.Logo}>
          <Logo />
        </div>
        <nav>
          <NavigationItems
            isAuth={props.isAuth}
            isAdmin={props.isAdmin}
            isGuest={props.isGuest}
            noOrders={props.noOrders}
            noResults={props.noResults}
            {...props}
          />
        </nav>
      </div>
    </React.Fragment>
  );
};

export default sideDrawer;
